import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { RiskFlag } from '$/requests/GovernanceCheck.ts';

const RiskFlagsList: FC<{ flags: RiskFlag[] }> = ({ flags }) => {
  const { t } = useTranslation();
  if (flags.length === 0) return null;

  return (
    <ul className="flex flex-col gap-2">
      {flags.map((flag) => (
        <li
          key={flag.filter_name}
          className="font-dm text-xs text-black/70 rounded-lg border border-[rgba(0,0,0,0.08)] bg-white px-3 py-2"
        >
          <span className="font-bold">{flag.filter_name}</span>
          <span className="text-black/45">
            {' '}
            · {t(`recommendationEnginePage.compass.filterStatus.${flag.status}`)}
          </span>
          {flag.summary && <p className="mt-1 leading-relaxed">{flag.summary}</p>}
        </li>
      ))}
    </ul>
  );
};

export default RiskFlagsList;
